import { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";

export default function TrackerAdmin() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const q = query(
      collection(db, "stats"),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(q, (snap) => {
      const map = {};

      snap.docs.forEach((doc) => {
        const data = doc.data();
        const id = data.visitorId;

        if (!map[id]) {
          map[id] = {
            visitorId: id,
            entries: [],
          };
        }

        map[id].entries.push({
          path: data.path,
          createdAt: data.createdAt,
        });
      });

      setUsers(Object.values(map));
    });

    return () => unsub();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-2xl font-bold mb-6">📊 Admin – Visitor Timeline</h1>

      <div className="space-y-6">
        {users.map((user) => (
          <div
            key={user.visitorId}
            className="bg-white rounded shadow p-4"
          >
            <div className="mb-3">
              <div className="font-mono text-xs break-all">
                {user.visitorId}
              </div>
              <div className="text-sm text-gray-500">
                Entries: {user.entries.length}
              </div>
            </div>

            <ul className="border-l pl-4 space-y-2">
              {user.entries.map((e, i) => (
                <li key={i} className="text-sm">
                  <div className="font-medium">{e.path}</div>
                  <div className="text-xs text-gray-400">
                    {e.createdAt?.toDate
                      ? e.createdAt.toDate().toLocaleString()
                      : ""}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}

        {users.length === 0 && (
          <div className="text-center text-gray-500">
            No data yet
          </div>
        )}
      </div>
    </div>
  );
}